var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MtxSvg',{staticClass:"mtx-loading",attrs:{"src":"icon-ripple","fill":""}})}
var staticRenderFns = []

export { render, staticRenderFns }